import { render, staticRenderFns } from "./CsButton.vue?vue&type=template&id=c6dd7080&scoped=true&functional=true&lang=pug"
import script from "./CsButton.vue?vue&type=script&lang=ts"
export * from "./CsButton.vue?vue&type=script&lang=ts"
import style0 from "./CsButton.vue?vue&type=style&index=0&id=c6dd7080&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "c6dd7080",
  null
  
)

export default component.exports